module.exports = __webpack_public_path__ + "static/media/settings.cd7e9298.gif";